<template>
  <b-modal
    id="detail-permohonan-modal"
    ref="modalRef"
    size="xl"
    body-class="bg-white"
    @close="closeModal"
    @hide="closeModal"
  >
    <!-- Modal Header Custom Title (Persis Kode B) -->
    <template #modal-title>
      <span>Daftar Permohonan: {{ dataModal.label || 'Semua Permohonan' }}</span>
    </template>

    <template>
      <!-- Controls Top Bar (Persis Kode B) -->
      <div class="d-flex justify-content-between mb-4">
        <div>
          <button type="button" class="btn btn-success" @click="exportData">
            <i class="fa fa-file-text-o"></i> Excel
          </button>
        </div>
        <div class="d-flex">
          <div class="d-flex">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mr-2 mb-0">Search: </label>
              <input
                v-model="search.value"
                type="text"
                class="form-control"
                id="search"
                @keyup.enter="handleSearch"
              />
            </div>
            <div class="mr-2">
              <select v-model="search.field" class="form-control">
                <option value="nama_pemohon">Nama Pemohon</option>
                <option value="nomor_permohonan">Nomor Pemohon</option>
                <option value="jenis_kegiatan">Jenis Kegiatan</option>
                <option :value="dataModal.label === 'Berusaha' ? 'tanggal_pada_permohonan' : 'tanggal_permohonan'">
                  Tgl Permohonan
                </option>
              </select>
            </div>
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click="handleSearch"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
          <div class="d-flex ml-4">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mb-0">Sort By: </label>
            </div>
            <div>
              <select v-model="sort.field" class="form-control" @change="handleSearch">
                <option value="createdAt">Tgl Submit</option>
                <option :value="dataModal.label === 'Berusaha' ? 'tanggal_pada_permohonan' : 'tanggal_permohonan'">
                  Tgl Permohonan
                </option>
              </select>
            </div>
            <div class="ml-2">
              <select v-model="sort.direction" class="form-control" @change="handleSearch">
                <option value="DESC">DESC</option>
                <option value="ASC">ASC</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="isLoading" class="text-center py-5">
        <b-spinner variant="primary" class="mb-2"></b-spinner>
        <p class="text-muted small mb-0">Memuat data permohonan...</p>
      </div>

      <!-- Empty State -->
      <div v-else-if="dataPermohonan.length === 0" class="text-center py-5">
        <h6 class="font-weight-bold text-dark">Tidak Ada Data</h6>
        <p class="text-muted small mb-0">Belum ada berkas permohonan ditemukan.</p>
      </div>

      <!-- Table Tampilan Kode B -->
      <table v-else class="table">
        <thead>
          <tr>
            <th scope="col">No</th>
            <th scope="col">No. Permohonan</th>
            <th scope="col">Nama Pemohon</th>
            <th scope="col">Tgl Permohonan</th>
            <th scope="col">Lokasi / Kegiatan</th>
            <th scope="col" class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="d in dataPermohonan" :key="d.id">
            <td>{{ d.no }}</td>
            <td>{{ d.nomor_permohonan || '-' }}</td>
            <td>
              <div style="width: 250px; text-wrap: wrap">
                {{ d.nama_pemohon }}
              </div>
            </td>
            <td>
              {{ dataModal.label === 'Berusaha' ? formatDates(d.tanggal_pada_permohonan) : formatDates(d.tanggal_permohonan) }}
            </td>
            <td>
              <div style="width: 250px; text-wrap: wrap">
                {{ dataModal.label === 'Berusaha' ? d.lokasi : d.provinsi }}
              </div>
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-outline-primary rounded-pill px-3"
                @click="goToDetail(d.id)"
              >
                Detail
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Pagination Footer Tampilan Kode B -->
      <div class="d-flex justify-content-between align-items-center pt-2">
        <div>{{ pagesText }}</div>
        <ul class="pagination mb-0">
          <li class="page-item" :class="{ disabled: pagination.currentPage === 1 }">
            <button
              class="page-link"
              @click="goToPage(pagination.currentPage - 1)"
            >
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li
            v-for="(page, index) in pages"
            :key="index"
            class="page-item"
            :class="{ active: page == pagination.currentPage, disabled: page === '...' }"
          >
            <button
              v-if="page !== '...'"
              class="page-link"
              @click="goToPage(page)"
            >
              {{ page }}
            </button>
            <span v-else class="page-link">...</span>
          </li>
          <li class="page-item" :class="{ disabled: pagination.currentPage === pagination.totalPages }">
            <button
              class="page-link"
              @click="goToPage(pagination.currentPage + 1)"
            >
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </div>
    </template>

    <!-- Modal Footer Kode B -->
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="closeModal"
        >
          Tutup
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import axios from 'axios'
import { formatDate } from '../../../../helper/helpernew'
import dayjs from 'dayjs'
import * as xlsx from 'xlsx'
import Swal from 'sweetalert2'

export default {
  name: 'DetailModal',
  props: {
    filterTahun: {
      type: [String, Number],
      default: new Date().getFullYear(),
    },
  },
  data() {
    return {
      isLoading: false,
      baseapi: localStorage.getItem('baseapi') || '',
      dataModal: {
        label: '',
        color: '',
      },
      dataPermohonan: [],
      pagination: {
        currentPage: 1,
        total: 0,
        totalPages: 1,
        limit: 10,
      },
      search: {
        field: 'nama_pemohon',
        value: '',
      },
      sort: {
        field: 'createdAt',
        direction: 'DESC',
      },
    }
  },
  computed: {
    pages() {
      return this.generatePagination(
        this.pagination.currentPage,
        this.pagination.totalPages
      )
    },
    pagesText() {
      const { currentPage, limit, total } = this.pagination
      const startData = (currentPage - 1) * limit + 1
      const endData = Math.min(currentPage * limit, total)
      if (total <= 0) return 'Tidak ada data'
      return `Menampilkan ${startData} sampai ${endData} dari ${total} data`
    },
  },
  methods: {
    closeModal() {
      if (this.$refs.modalRef) {
        this.$refs.modalRef.hide()
      }
    },

    getApiOption() {
      const user = JSON.parse(localStorage.getItem('user') || '{}')
      return {
        headers: {
          Authorization: `Bearer ` + (user?.accessToken || ''),
        },
      }
    },

    formatDates(value) {
      return formatDate(value, 'DD MMM YYYY')
    },

    async showModal(selectedInfo) {
      this.dataModal = { ...selectedInfo }
      this.pagination.currentPage = 1
      this.search.value = ''

      if (this.$refs.modalRef) {
        this.$refs.modalRef.show()
      }

      await this.loadData()
    },

    async loadData() {
      this.isLoading = true
      try {
        const firstDate = `${this.dataModal.tahun}-01-01`
        const lastDate = `${this.dataModal.tahun}-12-31`

        const jenis_permohonan = this.dataModal.label === 'Berusaha' ? 'permohonan' : 'permohonan_nonberusaha'
        const tanggal_filter = this.dataModal.label === 'Berusaha' ? 'tanggal_pada_permohonan' : 'tanggal_permohonan'

        const api =
          `api/${jenis_permohonan}/dataTable` +
          `?page=${this.pagination.currentPage}` +
          `&filter=${tanggal_filter},>=,${firstDate};${tanggal_filter},<=,${lastDate}` +
          `;${this.dataModal.filter}` +
          `${
            this.search.value !== ''
              ? `;${this.search.field},${this.search.field === 'tanggal_pada_permohonan' ? '=' : 'like'},${this.search.value}`
              : ''
          }` +
          `&sort=${this.sort.field},${this.sort.direction}`

        const res = await axios.get(this.baseapi + api, this.getApiOption())
        const resData = res.data

        this.pagination.totalPages = Math.ceil(resData.total / (resData.limit || this.pagination.limit))
        this.pagination.total = resData.total

        const { currentPage, limit } = this.pagination
        this.dataPermohonan = (resData.data || []).map((d, i) => {
          return {
            ...d,
            no: (currentPage - 1) * limit + i + 1,
          }
        })
      } catch (error) {
        console.error('Gagal memuat data datatable:', error)
        this.dataPermohonan = []
      } finally {
        this.isLoading = false
      }
    },

    async exportData() {
      if (this.$loading) this.$loading(true)
      try {
        const firstDate = `${this.dataModal.tahun}-01-01`
        const lastDate = `${this.dataModal.tahun}-12-31`
        const jenis_permohonan = this.dataModal.label === 'Berusaha' ? 'permohonan' : 'permohonan_nonberusaha'
        const tanggal_filter = this.dataModal.label === 'Berusaha' ? 'tanggal_pada_permohonan' : 'tanggal_permohonan'

        const api =
          `api/${jenis_permohonan}` +
          `?sort=${this.sort.field},${this.sort.direction}` +
          `&filter=${tanggal_filter},>=,${firstDate};${tanggal_filter},<=,${lastDate};${this.dataModal.filter}` +
          `${
            this.search.value !== ''
              ? `;${this.search.field},${this.search.field === 'tanggal_pada_permohonan' ? '=' : 'like'},${this.search.value}`
              : ''
          }`

        const res = await axios.get(this.baseapi + api, this.getApiOption())

        const worksheetData = [
          ['Data Permohonan'],
          ['No', 'Nama Pemohon', 'Nomor Pemohon', 'Jenis Kegiatan', 'Tanggal Pengajuan', 'Lokasi / Provinsi'],
        ]

        ;(res.data.data || []).forEach((d, i) => {
          worksheetData.push([
            i + 1,
            d.nama_pemohon,
            d.nomor_permohonan,
            d.jenis_kegiatan,
            d.tanggal_pada_permohonan || d.tanggal_permohonan,
            d.lokasi || d.provinsi,
          ])
        })

        const workbook = xlsx.utils.book_new()
        const worksheet = xlsx.utils.aoa_to_sheet(worksheetData)
        xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

        xlsx.writeFile(
          workbook,
          `Data_Permohonan_${this.dataModal.label}_${dayjs().format('YYYY-MM-DD')}.xlsx`
        )
      } catch (e) {
        Swal.fire('Gagal', 'Gagal mengekspor data', 'error')
      } finally {
        if (this.$loading) this.$loading(false)
      }
    },

    goToPage(page) {
      if (
        page >= 1 &&
        page <= this.pagination.totalPages &&
        page !== this.pagination.currentPage
      ) {
        this.pagination.currentPage = Number(page)
        this.loadData()
      }
    },

    generatePagination(currentPage, totalPages) {
      const [cp, tp] = [currentPage, totalPages]
      const pagination = []
      if (tp <= 7) {
        for (let i = 1; i <= tp; i++) pagination.push(`${i}`)
      } else {
        if (cp <= 3) {
          pagination.push('1', '2', '3', '4', '5', '...', `${tp}`)
        } else if (cp >= tp - 2) {
          pagination.push('1', '...', `${tp - 4}`, `${tp - 3}`, `${tp - 2}`, `${tp - 1}`, `${tp}`)
        } else {
          pagination.push('1', '...', `${cp - 1}`, `${cp}`, `${cp + 1}`, '...', `${tp}`)
        }
      }
      return pagination
    },

    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },

    goToDetail(id) {
      this.closeModal()
      if (id && this.$router) {
        if (this.dataModal.label === 'Berusaha') {
          this.$router.push(`/app/perizinan/detail-perizinan/${id}`)
        } else {
          this.$router.push(`/app/nonberusaha/detail-perizinan/${id}`)
        }
      }
    },
  },
}
</script>